<template>
  <div class="top-nav-wrapper">
    <router-link to="/main-page">Home</router-link>
    <router-link to="basic-info"> Basic info </router-link>
    <router-link to="commercial-terms"> Commercial terms </router-link>
    <router-link to="security-instruments"> Security instruments </router-link>
    <router-link to="ifrs-16"> IFRS 16 </router-link>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .top-nav-wrapper {
    /* border: 1px dashed white; */
    padding: 20px 0; 
    margin-bottom: 20px;
  }
  .top-nav-wrapper a {
    font-weight: bold;
    text-decoration: none;
    color: var(--font);
    margin-right: 15px;
    font-weight: 300;
  }
  .top-nav-wrapper a.router-link-exact-active {
    color: var(--primary);
  }


  
</style>